import { useFormContext } from 'react-hook-form'

import Button from '@ui-kit/components/Button'
import type { NativeProps } from '@ui-kit/components/Button/types'

import type { UseZodForm } from './ZodForm'

type AnyZodForm = UseZodForm<any>

export const ZodSubmitButton = (
  props: Omit<React.ComponentProps<'button'>, 'type' | 'form' | 'style'> &
    NativeProps & {
      form?: AnyZodForm
      loading: boolean
      label: string
      disabled?: boolean
    }
) => {
  const context = useFormContext()

  const form = (props.form ?? context) as AnyZodForm | null
  if (!form) {
    throw new Error('SubmitButton must be used within a Form or have a form prop')
  }

  const { isValid } = form.formState
  const isDisabled = !isValid || props.disabled === true

  const submitForm = () => {
    if (isDisabled) {
      return
    }

    const formElement = document.getElementById(form.id)
    if (formElement instanceof HTMLFormElement) {
      formElement.requestSubmit()
    }
  }

  return (
    <Button
      id="proceed_button"
      variantColor="black"
      uppercase
      type={props.type}
      label={props.label}
      isLoading={props.loading}
      disabled={isDisabled}
      onPress={submitForm}
    />
  )
}
